// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Vue
import { createApp } from 'vue'
import HomePage from '@components/HomePage.vue'

// Vuetify configuration
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
  },
})

// Mount HomePage to #home-app mount point
function mountHomePage() {
  const el = document.getElementById('home-app')
  if (el && !el.__vue_app__) {
    // Get data attributes passed from Rails
    const categoriesData = el.dataset.categories ? JSON.parse(el.dataset.categories) : []
    const translations = el.dataset.translations ? JSON.parse(el.dataset.translations) : {}
    const resultPath = el.dataset.resultPath || '/result'
    const buttonColor = el.dataset.buttonColor || '#0275d8'
    const helpCentreUrl = el.dataset.helpCentreUrl || 'https://help.mygameday.app/help'
    const newTicketUrl = el.dataset.newTicketUrl || '/topics/new'

    const app = createApp(HomePage, {
      categoriesData,
      translations,
      resultPath,
      buttonColor,
      helpCentreUrl,
      newTicketUrl
    })

    app.use(vuetify)
    app.mount('#home-app')
  }
}

// Mount on DOM ready (for initial page load)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountHomePage)
} else {
  mountHomePage()
}

// For Turbolinks support
document.addEventListener('turbolinks:load', mountHomePage)

// Clean up on Turbolinks navigation
document.addEventListener('turbolinks:before-visit', () => {
  const el = document.getElementById('home-app')
  if (el && el.__vue_app__) {
    el.__vue_app__.unmount()
    delete el.__vue_app__
  }
})
